'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var RowParent = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: none;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-wrap: none;\n  justify-content: space-between;\n"])));
var ComponentContainer = styled__default(
// eslint-disable-next-line react/jsx-props-no-spreading
function (_a) {
    var noMargin = _a.noMargin, props = tslib.__rest(_a, ["noMargin"]);
    return React__default.createElement("div", tslib.__assign({}, props), props.children);
})(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (props) { return (props.noMargin ? '0' : '1rem'); });
var templateObject_1, templateObject_2;

exports.ComponentContainer = ComponentContainer;
exports.RowParent = RowParent;
